// import React, { useState, useCallback, useEffect, memo } from "react";
// import {
//   Grid,
//   Typography,
//   TextField,
//   Button,
//   InputAdornment,
//   IconButton,
//   Chip,
//   Fade,
//   Zoom,
//   Slide,
// } from "@material-ui/core";
// import { Autocomplete } from "@material-ui/lab";
// import SearchIcon from "@material-ui/icons/Search";
// import ClearIcon from "@material-ui/icons/Clear";
// import { makeStyles } from "@material-ui/core/styles";
// import { useSnackbar } from "./SnackbarProvider";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     zIndex: 3,
//     position: "relative",
//     background: "linear-gradient(135deg, #0b416dff 0%, #104068ff 100%)",
//     borderRadius: "10px",
//     padding: "10px",
//     backdropFilter: "blur(20px)",
//     border: "1px solid rgba(255, 255, 255, 0.2)",
//     boxShadow:
//       "0 20px 40px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
//     // overflow: "hidden",
//     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//     "&::before": {
//       background:
//         "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)",
//       transition: "left 0.6s",
//     },
//     "&:hover::before": {
//       // left: "100%",
//     },
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     // marginBottom: "20px",
//     position: "relative",
//   },
//   title: {
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     fontWeight: 700,
//     fontSize: "1.5rem",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//   },
//   filterCount: {
//     background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
//     color: "white",
//     borderRadius: "20px",
//     padding: "4px 12px",
//     fontSize: "0.75rem",
//     fontWeight: 600,
//     boxShadow: "0 4px 15px rgba(238, 90, 36, 0.3)",
//     animation: "$pulse 2s infinite",
//   },
//   "@keyframes pulse": {
//     "0%": { transform: "scale(1)" },
//     "50%": { transform: "scale(1.05)" },
//     "100%": { transform: "scale(1)" },
//   },
//   filterGrid: {
//     display: "flex",
//     alignContent: "center",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: "16px",
//     alignItems: "flex-end",
//     position: "relative",
//   },
//   filterItem: {
//     minWidth: "300px",
//     maxWidth: "300px",
//     flex: "1",
//     width: "100%",
//     // display:"flex",
//     position: "relative",
//     "&::before": {
//       content: '""',
//       position: "absolute",
//       bottom: "-2px",
//       left: "50%",
//       width: "0",
//       height: "2px",
//       background: "linear-gradient(90deg, #667eea, #764ba2)",
//       transition: "all 0.3s ease",
//       transform: "translateX(-50%)",
//     },
//     "&:hover::before": {
//       width: "100%",
//     },
//   },
//   filterItem2: {
//     // minWidth: "300px",
//     // maxWidth: "300px",
//     // flex: "1",
//     // width: "100%",
//     // display:"flex",
//     position: "relative",
//     "&::before": {
//       content: '""',
//       position: "absolute",
//       bottom: "-2px",
//       left: "50%",
//       width: "0",
//       height: "2px",
//       background: "linear-gradient(90deg, #667eea, #764ba2)",
//       transition: "all 0.3s ease",
//       transform: "translateX(-50%)",
//     },
//     "&:hover::before": {
//       // width: "100%",
//     },
//   },
//   modernTextField: {
//     "& .MuiOutlinedInput-root": {
//       background: "rgba(255, 255, 255, 0.9)",
//       borderRadius: "16px",
//       transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//       backdropFilter: "blur(10px)",
//       "& fieldset": {
//         border: "2px solid rgba(102, 126, 234, 0.2)",
//         transition: "all 0.3s ease",
//       },
//       "&:hover": {
//         background: "rgba(255, 255, 255, 0.95)",
//         transform: "translateY(-1px)",
//         boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
//         "& fieldset": {
//           border: "2px solid rgba(102, 126, 234, 0.4)",
//         },
//       },
//       "&.Mui-focused": {
//         background: "rgba(255, 255, 255, 1)",
//         transform: "translateY(-2px)",
//         boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
//         "& fieldset": {
//           border: "2px solid #667eea",
//         },
//       },
//     },
//   },
//   modernAutocomplete: {
//     "& .MuiOutlinedInput-root": {
//       background: "rgba(255, 255, 255, 0.9)",
//       borderRadius: "16px",
//       transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//       backdropFilter: "blur(10px)",
//       "& .MuiAutocomplete-inputRoot": {
//         padding: "0 !important",
//       },
//       "MuiFormControl-fullWidth": {
//         maxWidth: "10%",
//       },
//       "& input": {
//         padding: "5px 14px !important",
//       },
//       "& fieldset": {
//         border: "2px solid rgba(102, 126, 234, 0.2)",
//       },
//       "&:hover": {
//         background: "rgba(255, 255, 255, 0.95)",
//         transform: "translateY(-1px)",
//         boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
//         "& fieldset": {
//           border: "2px solid rgba(102, 126, 234, 0.4)",
//         },
//       },
//       "&.Mui-focused": {
//         background: "rgba(255, 255, 255, 1)",
//         transform: "translateY(-2px)",
//         boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
//         "& fieldset": {
//           border: "2px solid #667eea",
//         },
//       },
//     },
//   },
//   gradientButton: {
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     borderRadius: "16px",
//     // minWidth: "100px",
//     // maxWidth: "100px",
//     padding: "5px 20px",
//     color: "white",
//     fontWeight: 600,
//     fontSize: "0.95rem",
//     textTransform: "none",
//     boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
//     border: "none",
//     // position: "relative",
//     // overflow: "hidden",
//     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//     "&:hover": {
//       transform: "translateY(-2px)",
//       // boxShadow: "0 12px 35px rgba(102, 126, 234, 0.4)",
//       background: "linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%)",
//     },
//     "&:active": {
//       transform: "translateY(0)",
//     },
//     "&::before": {
//       content: '""',
//       // position: "absolute",
//       // top: 0,
//       // left: "-100%",
//       // width: "100%",
//       // height: "100%",
//       background:
//         "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
//       transition: "left 0.5s",
//     },
//     "&:hover::before": {
//       // left: "100%",
//     },
//   },
//   searchButton: {
//     background: "linear-gradient(135deg, #003a6b 0%, #003a6b 100%)",
//     borderRadius: "50%",
//     // width: "10px",
//     // height: "10px",
//     // minWidth: "20px",
//     boxShadow: "0 8px 25px rgba(238, 90, 36, 0.3)",
//     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//     "&:hover": {
//       transform: "rotate(90deg) scale(1.1)",
//       boxShadow: "0 12px 35px rgba(238, 90, 36, 0.4)",
//     },
//   },
//   clearButton: {
//     background: "linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)",
//     color: "white",
//     borderRadius: "12px",
//     padding: "8px 16px",
//     fontSize: "0.85rem",
//     fontWeight: 500,
//     boxShadow: "0 6px 20px rgba(9, 132, 227, 0.3)",
//     transition: "all 0.3s ease",
//     "&:hover": {
//       transform: "translateY(-1px)",
//       boxShadow: "0 8px 25px rgba(9, 132, 227, 0.4)",
//     },
//   },
//   activeFiltersSection: {
//     marginTop: "20px",
//     padding: "16px",
//     background: "rgba(255, 255, 255, 0.5)",
//     borderRadius: "16px",
//     backdropFilter: "blur(10px)",
//     border: "1px solid rgba(255, 255, 255, 0.3)",
//   },
//   activeFilterChip: {
//     background: "linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%)",
//     color: "white",
//     margin: "4px",
//     fontWeight: 500,
//     boxShadow: "0 4px 15px rgba(108, 92, 231, 0.3)",
//     transition: "all 0.3s ease",
//     "&:hover": {
//       transform: "translateY(-2px)",
//       boxShadow: "0 6px 20px rgba(108, 92, 231, 0.4)",
//     },
//   },
//   dateField: {
//     "& .MuiOutlinedInput-root": {
//       background: "rgba(255, 255, 255, 0.9)",
//       borderRadius: "16px",
//       transition: "all 0.3s ease",
//       "& fieldset": {
//         border: "2px solid rgba(102, 126, 234, 0.2)",
//       },
//       "&:hover": {
//         background: "rgba(255, 255, 255, 0.95)",
//         transform: "translateY(-1px)",
//         "& fieldset": {
//           border: "2px solid rgba(102, 126, 234, 0.4)",
//         },
//       },
//       "&.Mui-focused": {
//         background: "rgba(255, 255, 255, 1)",
//         "& fieldset": {
//           border: "2px solid #667eea",
//         },
//       },
//     },
//   },
// }));

// /**
//  * Separate FilterItem component
//  * Memoized so it only re-renders if its props change
//  */
// const FilterItem = memo(function FilterItem({
//   filterConfig,
//   index,
//   handleFilterChange,
//   classes,
//   showSnackbar,
// }) {
//   const {
//     label,
//     options,
//     type,
//     placeholder,
//     disabled,
//     onChangeHandler,
//     onClickHandler,
//     optionKey,
//     value,
//     dateType,
//     name,
//     isShow,
//     showSerchIcon,
//     buttonText,
//   } = filterConfig;

//   // Get current date and time for max attributes
//   const getMaxDateTime = () => {
//     const now = new Date();

//     if (dateType === "datetime-local") {
//       // For datetime-local type (YYYY-MM-DDTHH:mm)
//       const year = now.getFullYear();
//       const month = String(now.getMonth() + 1).padStart(2, "0");
//       const day = String(now.getDate()).padStart(2, "0");
//       const hours = String(now.getHours()).padStart(2, "0");
//       const minutes = String(now.getMinutes()).padStart(2, "0");

//       return `${year}-${month}-${day}T${hours}:${minutes}`;
//     } else {
//       // For date type (YYYY-MM-DD)
//       return now.toISOString().split("T")[0];
//     }
//   };

//   const maxDateTime = getMaxDateTime();

//   // Validate if the selected date/time is in future
//   const isFutureDateTime = (selectedValue) => {
//     if (!selectedValue) return false;

//     const selected = new Date(selectedValue);
//     const now = new Date();

//     return selected > now;
//   };

//   if (isShow === false) return null;

//   return (
//     <Slide in={true} timeout={300 + index * 100} direction="up" key={index}>
//       <div
//         className={type !== "button" ? classes.filterItem : classes.filterItem2}
//       >
//         {type === "date" ? (
//           <TextField
//             type={dateType || "date"}
//             variant="outlined"
//             size="small"
//             fullWidth
//             name={name || ""}
//             className={classes.dateField}
//             value={value || ""}
//             onChange={(event) => {
//               const newVal = event.target.value;
//               if (isFutureDateTime(newVal)) {
//                 showSnackbar("Future dates/times are not allowed", "error");
//                 return;
//               }
//               handleFilterChange(index, newVal, label);
//               onChangeHandler?.(newVal, name);
//             }}
//             InputLabelProps={{ shrink: true }}
//             inputProps={{
//               max: maxDateTime,
//             }}
//             // error={value && isFutureDateTime(value)}
//             // helperText={
//             //   value && isFutureDateTime(value)
//             //     ? dateType === "datetime-local"
//             //       ? "Future dates and times are not allowed"
//             //       : "Future dates are not allowed"
//             //     : ""
//             // }
//           />
//         ) : type === "button" ? (
//           <Button
//             variant="contained"
//             onClick={onClickHandler}
//             className={classes.gradientButton}
//           >
//             {buttonText}
//           </Button>
//         ) : type === "search" ? (
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder={placeholder}
//             size="small"
//             name={name || ""}
//             className={classes.modernTextField}
//             value={value || ""}
//             onChange={(e) => {
//               const newVal = e.target.value;
//               handleFilterChange(index, newVal, label);
//               onChangeHandler?.(newVal, name);
//             }}
//             InputProps={
//               showSerchIcon !== false && {
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={onClickHandler}
//                       className={classes.searchButton}
//                       size="small"
//                     >
//                       <SearchIcon style={{ color: "white" }} />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }
//             }
//           />
//         ) : type === "textField" ? (
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder={placeholder}
//             size="small"
//             name={name || ""}
//             className={classes.modernTextField}
//             value={value || ""}
//             disabled={disabled}
//             onChange={(e) => {
//               const newVal = e.target.value;
//               handleFilterChange(index, newVal, label);
//               onChangeHandler?.(newVal, name);
//             }}
//           />
//         ) : type === "autocomplete" ? (
//           <Autocomplete
//             fullWidth
//             options={options || []}
//             className={classes.modernAutocomplete}
//             getOptionLabel={(option) =>
//               (optionKey ? option?.[optionKey] : option) || ""
//             }
//             disabled={disabled}
//             filterSelectedOptions
//             disablePortal
//             name={name || ""}
//             value={value || null}
//             onChange={(event, newValue) => {
//               handleFilterChange(index, newValue, label);
//               onChangeHandler?.(newValue, name);
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 variant="outlined"
//                 size="small"
//                 placeholder={placeholder}
//                 fullWidth
//               />
//             )}
//           />
//         ) : null}
//       </div>
//     </Slide>
//   );
// });
// const EnhancedTableToolbar = memo(({ dropdowns, mapviewpage }) => {
//   const classes = useStyles();
//   const [activeFilters, setActiveFilters] = useState([]);
//   const [isExpanded] = useState(true);
//   const { showSnackbar } = useSnackbar();

//   // Initialize active filters only when dropdowns change
//   useEffect(() => {
//     if (!dropdowns) return;

//     const initialFilters = dropdowns
//       .map((filterConfig, index) => {
//         const { label, value, type } = filterConfig;

//         if (type === "button" || !value) return null;

//         let filterText = "";
//         if (typeof value === "object" && value !== null) {
//           filterText = value.name || value.label || value.toString();
//         } else if (typeof value === "string" && value.trim() !== "") {
//           filterText = value;
//         } else if (typeof value === "number") {
//           filterText = value.toString();
//         }
//         return filterText ? { index, label, value: filterText } : null;
//       })
//       .filter(Boolean);

//     setActiveFilters(initialFilters);
//   }, [dropdowns]);

//   // stable handler
//   const handleFilterChange = useCallback((index, value, label) => {
//     if (value && value !== "") {
//       const filterText =
//         typeof value === "object"
//           ? value.name || value.label || value.toString()
//           : value;
//       setActiveFilters((prev) => {
//         const existing = prev.findIndex((f) => f.index === index);
//         if (existing >= 0) {
//           const newFilters = [...prev];
//           newFilters[existing] = { index, label, value: filterText };
//           return newFilters;
//         }
//         return [...prev, { index, label, value: filterText }];
//       });
//     } else {
//       setActiveFilters((prev) => prev.filter((f) => f.index !== index));
//     }
//   }, []);
//   const siteCategoryColours = {
//     UNLOADING: "#FFA500",
//     AREA: "#00008B",
//     LOADING: "#008000",
//     YARD: "#800080",
//     REGION: "#FF7F7F",
//     HYBRID: "#ADD8E6",
//     MINE: "#8B0000",
//     BOUNDARY: "#FFFF00",
//   };
//   return (
//     <div className={classes.container}>
//       <Fade in={isExpanded} timeout={500}>
//         <div className={classes.filterGrid}>
//           {dropdowns?.map((filterConfig, index) => (
//             <FilterItem
//               key={index}
//               filterConfig={filterConfig}
//               index={index}
//               handleFilterChange={handleFilterChange}
//               classes={classes}
//               showSnackbar={showSnackbar}
//             />
//           ))}
//           {mapviewpage && (
//             <Fade in={true} timeout={700}>
//               <Slide direction="up" in={true} timeout={600}>
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "65px",
//                     right: "45px",
//                     background: "rgba(255,255,255,0.9)",
//                     padding: "5px 12px",
//                     borderRadius: "8px",
//                     display: "flex",
//                     gap: "8px",
//                     zIndex: 3,
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
//                     minWidth: "150px",
//                   }}
//                 >
//                   {Object.entries(siteCategoryColours).map(([key, color]) => (
//                     <div
//                       key={key}
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "5px",
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: "14px",
//                           height: "14px",
//                           backgroundColor: color,
//                           borderRadius: "3px",
//                           border: "1px solid #999",
//                         }}
//                       />
//                       <span style={{ fontSize: "12px", fontWeight: 500 }}>
//                         {key}
//                       </span>
//                     </div>
//                   ))}
//                 </div>
//               </Slide>
//             </Fade>
//           )}
//         </div>
//       </Fade>
//     </div>
//   );
// });

// export default EnhancedTableToolbar;

import React, { useState, useCallback, useEffect, memo } from "react";
import {
  Grid,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Chip,
  Fade,
  Zoom,
  Slide,
  Drawer,
  Divider,
  Popper,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import FilterListIcon from "@material-ui/icons/FilterList";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "./SnackbarProvider";

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 3,
    position: "relative",
    background: "linear-gradient(135deg, #0b416dff 0%, #104068ff 100%)",
    borderRadius: "10px",
    padding: "10px",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    boxShadow:
      "0 20px 40px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
  },
  title: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 700,
    fontSize: "1.5rem",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  filterCount: {
    background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
    color: "white",
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "0.75rem",
    fontWeight: 600,
    boxShadow: "0 4px 15px rgba(238, 90, 36, 0.3)",
    animation: "$pulse 2s infinite",
  },
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.05)" },
    "100%": { transform: "scale(1)" },
  },
  filterGrid: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-end",
    position: "relative",
  },
  filterItem: {
    minWidth: "300px",
    maxWidth: "300px",
    flex: "1",
    width: "100%",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "-2px",
      left: "50%",
      width: "0",
      height: "2px",
      background: "linear-gradient(90deg, #667eea, #764ba2)",
      transition: "all 0.3s ease",
      transform: "translateX(-50%)",
    },
    "&:hover::before": {
      width: "100%",
    },
  },
  filterItem2: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      bottom: "-2px",
      left: "50%",
      width: "0",
      height: "2px",
      background: "linear-gradient(90deg, #667eea, #764ba2)",
      transition: "all 0.3s ease",
      transform: "translateX(-50%)",
    },
  },
  modernTextField: {
    "& .MuiOutlinedInput-root": {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "16px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backdropFilter: "blur(10px)",
      "& fieldset": {
        border: "2px solid rgba(102, 126, 234, 0.2)",
        transition: "all 0.3s ease",
      },

      "&:hover": {
        background: "rgba(255, 255, 255, 0.95)",
        transform: "translateY(-1px)",
        boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
        "& fieldset": {
          border: "2px solid rgba(102, 126, 234, 0.4)",
        },
      },
      "&.Mui-focused": {
        background: "rgba(255, 255, 255, 1)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
        "& fieldset": {
          border: "2px solid #667eea",
        },
      },
    },
  },
  modernAutocomplete: {
    "& .MuiOutlinedInput-root": {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "16px",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      backdropFilter: "blur(10px)",
      "& .MuiAutocomplete-inputRoot": {
        padding: "0px !important",
      },
      "& input": {
        padding: "5px 4px !important",
      },
      "& fieldset": {
        border: "2px solid rgba(102, 126, 234, 0.2)",
      },
      "&:hover": {
        background: "rgba(255, 255, 255, 0.95)",
        transform: "translateY(-1px)",
        boxShadow: "0 8px 25px rgba(102, 126, 234, 0.15)",
        "& fieldset": {
          border: "2px solid rgba(102, 126, 234, 0.4)",
        },
      },
      "&.Mui-focused": {
        background: "rgba(255, 255, 255, 1)",
        transform: "translateY(-2px)",
        boxShadow: "0 12px 30px rgba(102, 126, 234, 0.2)",
        "& fieldset": {
          border: "2px solid #667eea",
        },
      },
      // "&.MuiPaper-root":{
      //   marginTop:"-20px !important",
      //   background:"red !important"
      // }
    },
  },
  gradientButton: {
    marginTop: "20px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "16px",
    padding: "5px 20px",
    color: "white",
    fontWeight: 600,
    fontSize: "0.95rem",
    textTransform: "none",
    boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
    border: "none",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "translateY(-2px)",
      background: "linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
  filterButton: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    borderRadius: "16px",
    padding: "8px 16px",
    fontWeight: 600,
    boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 12px 35px rgba(102, 126, 234, 0.4)",
    },
  },
  searchButton: {
    background: "linear-gradient(135deg, #003a6b 0%, #003a6b 100%)",
    borderRadius: "50%",
    boxShadow: "0 8px 25px rgba(238, 90, 36, 0.3)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "rotate(90deg) scale(1.1)",
      boxShadow: "0 12px 35px rgba(238, 90, 36, 0.4)",
    },
  },
  clearButton: {
    background: "linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)",
    color: "white",
    borderRadius: "12px",
    padding: "8px 16px",
    fontSize: "0.85rem",
    fontWeight: 500,
    boxShadow: "0 6px 20px rgba(9, 132, 227, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 8px 25px rgba(9, 132, 227, 0.4)",
    },
  },
  drawer: {
    width: 420,
    flexShrink: 0,
  },
  drawerPaper: {
    width: 620,
    background: "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
    backdropFilter: "blur(10px)",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.3),
    background: "linear-gradient(135deg, #0b416dff 0%, #104068ff 100%)",
    color: "white",
  },
  drawerTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  drawerContent: {
    padding: theme.spacing(2),
    display: "flex",
    // flexDirection: "column",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  drawerFilterItem: {
    width: "280px",
    // display: "flex",
    // flexDirection: "column",
    // gap: theme.spacing(0.8),
  },
  drawerLabel: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#0b416d",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginLeft: "10px",
    marginBottom: "4px",
  },
  drawerButtonGroup: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: "1px solid rgba(0,0,0,0.1)",
  },
  dateField: {
    "& .MuiOutlinedInput-root": {
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "16px",
      transition: "all 0.3s ease",
      "& fieldset": {
        border: "2px solid rgba(102, 126, 234, 0.2)",
      },
      "&:hover": {
        background: "rgba(255, 255, 255, 0.95)",
        transform: "translateY(-1px)",
        "& fieldset": {
          border: "2px solid rgba(102, 126, 234, 0.4)",
        },
      },
      "&.Mui-focused": {
        background: "rgba(255, 255, 255, 1)",
        "& fieldset": {
          border: "2px solid #667eea",
        },
      },
    },
  },
  activeFilterChip: {
    background: "linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%)",
    color: "white",
    margin: "4px",
    fontWeight: 500,
    boxShadow: "0 4px 15px rgba(108, 92, 231, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 20px rgba(108, 92, 231, 0.4)",
    },
  },
}));

/**
 * Separate FilterItem component for Drawer
 */
const DrawerFilterItem = memo(function DrawerFilterItem({
  filterConfig,
  index,
  handleFilterChange,
  classes,
  showSnackbar,
}) {
  const {
    label,
    options,
    type,
    placeholder,
    disabled,
    onChangeHandler,
    onClickHandler,
    optionKey,
    value,
    dateType,
    name,
    isShow,
    showSerchIcon,
    buttonText,
    optionalOptionKey,
  } = filterConfig;

  const getMaxDateTime = () => {
    const now = new Date();
    if (dateType === "datetime-local") {
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } else {
      return now.toISOString().split("T")[0];
    }
  };

  const maxDateTime = getMaxDateTime();
  const isFutureDateTime = (selectedValue) => {
    if (!selectedValue) return false;
    const selected = new Date(selectedValue);
    const now = new Date();
    return selected > now;
  };

  if (isShow === false) return null;

  return (
    <div className={classes.drawerFilterItem}>
      <Typography className={classes.drawerLabel}>{label}</Typography>
      {type === "date" ? (
        <TextField
          type={dateType || "date"}
          variant="outlined"
          size="small"
          fullWidth
          name={name || ""}
          className={classes.dateField}
          value={value || ""}
          onChange={(event) => {
            const newVal = event.target.value;
            if (isFutureDateTime(newVal)) {
              showSnackbar("Future dates/times are not allowed", "error");
              return;
            }
            handleFilterChange(index, newVal, label);
            onChangeHandler?.(newVal, name);
          }}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            max: maxDateTime,
          }}
        />
      ) : type === "button" ? (
        <Button
          variant="contained"
          onClick={onClickHandler}
          className={classes.gradientButton}
          fullWidth
        >
          {buttonText}
        </Button>
      ) : type === "search" ? (
        <TextField
          fullWidth
          variant="outlined"
          placeholder={placeholder}
          size="small"
          name={name || ""}
          className={classes.modernTextField}
          value={value || ""}
          onChange={(e) => {
            const newVal = e.target.value;
            handleFilterChange(index, newVal, label);
            onChangeHandler?.(newVal, name);
          }}
          InputProps={
            showSerchIcon !== false && {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={onClickHandler}
                    className={classes.searchButton}
                    size="small"
                  >
                    <SearchIcon style={{ color: "white" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }
          }
        />
      ) : type === "textField" ? (
        <TextField
          fullWidth
          variant="outlined"
          placeholder={placeholder}
          size="small"
          name={name || ""}
          className={classes.modernTextField}
          value={value || ""}
          disabled={disabled}
          onChange={(e) => {
            const newVal = e.target.value;
            handleFilterChange(index, newVal, label);
            onChangeHandler?.(newVal, name);
          }}
        />
      ) : type === "autocomplete" ? (
        <Autocomplete
          fullWidth
          options={options || []}
          className={classes.modernAutocomplete}
          getOptionLabel={(option) =>
            option?.[optionKey] || option?.[optionalOptionKey] || option || ""
          }
          //   getOptionLabel={(option) => {
          //   return optionKey ? option?.[optionKey] || "" : option || "";
          // }}
          disabled={disabled}
          filterSelectedOptions
          disablePortal={true}
          name={name || ""}
          value={value || null}
          onChange={(event, newValue) => {
            handleFilterChange(index, newValue, label);
            onChangeHandler?.(newValue, name);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              margin="normal"
              size="small"
              placeholder={placeholder}
              fullWidth
            />
          )}
        />
      ) : null}
    </div>
  );
});

const EnhancedTableToolbar = memo(
  ({ dropdowns, mapviewpage, drawerOpen, setDrawerOpen, onFilterChange }) => {
    const classes = useStyles();
    const [activeFilters, setActiveFilters] = useState([]);
    const { showSnackbar } = useSnackbar();

    // useEffect(() => {
    //   if (!dropdowns) return;

    //   const initialFilters = dropdowns
    //     .map((filterConfig, index) => {
    //       const { label, value, type } = filterConfig;

    //       if (type === "button" || !value) return null;

    //       let filterText = "";
    //       if (typeof value === "object" && value !== null) {
    //         filterText = value.name || value.label || value.toString();
    //       } else if (typeof value === "string" && value.trim() !== "") {
    //         filterText = value;
    //       } else if (typeof value === "number") {
    //         filterText = value.toString();
    //       }
    //       return filterText ? { index, label, value: filterText } : null;
    //     })
    //     .filter(Boolean);

    //   setActiveFilters(initialFilters);
    // }, [dropdowns]);
    const handleFilterChange = useCallback(
      (index, value, label) => {
        setActiveFilters((prev) => {
          let newFilters;

          if (value && value !== "") {
            const filterText =
              typeof value === "object"
                ? value.name || value.label || value.toString()
                : value;

            const existing = prev.findIndex((f) => f.index === index);
            if (existing >= 0) {
              newFilters = [...prev];
              newFilters[existing] = { index, label, value: filterText };
            } else {
              newFilters = [...prev, { index, label, value: filterText }];
            }
          } else {
            newFilters = prev.filter((f) => f.index !== index);
          }

          // Notify parent component about filter changes
          onFilterChange?.(newFilters);
          return newFilters;
        });
      },
      [onFilterChange],
    );
    const handleClearFilters = () => {
      setActiveFilters([]);
      dropdowns?.forEach((config) => {
        if (config.onChangeHandler) {
          config.onChangeHandler("", config.name);
        }
      });
    };

    const siteCategoryColours = {
      UNLOADING: "#FFA500",
      AREA: "#00008B",
      LOADING: "#008000",
      YARD: "#800080",
      REGION: "#FF7F7F",
      HYBRID: "#ADD8E6",
      MINE: "#8B0000",
      BOUNDARY: "#FFFF00",
    };

    return (
      <>
        <div>
          <div className={classes.filterGrid}>
            {/* <Button
            variant="contained"
            startIcon={<FilterListIcon />}
            onClick={() => setDrawerOpen(true)}
            className={classes.filterButton}
          >
            Filters {activeFilters.length > 0 && `(${activeFilters.length})`}
          </Button> */}

            {mapviewpage && (
              <Fade in={true} timeout={700}>
                <Slide direction="up" in={true} timeout={600}>
                  <div
                    style={{
                      background: "rgba(255,255,255,0.9)",
                      padding: "5px 12px",
                      borderRadius: "8px",
                      display: "flex",
                      gap: "8px",
                      zIndex: 3,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      minWidth: "150px",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {Object.entries(siteCategoryColours).map(([key, color]) => (
                      <div
                        key={key}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <div
                          style={{
                            width: "14px",
                            height: "14px",
                            backgroundColor: color,
                            borderRadius: "3px",
                            border: "1px solid #999",
                          }}
                        />
                        <span style={{ fontSize: "12px", fontWeight: 500 }}>
                          {key}
                        </span>
                      </div>
                    ))}
                  </div>
                </Slide>
              </Fade>
            )}
          </div>
        </div>

        {/* Right Side Drawer for Filters */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          classes={{ paper: classes.drawerPaper }}
        >
          <div className={classes.drawerHeader}>
            <Typography className={classes.drawerTitle}>
              <FilterListIcon />
              All Filters
            </Typography>
            <IconButton
              onClick={() => setDrawerOpen(false)}
              style={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.drawerContent}>
            {dropdowns?.map((filterConfig, index) => (
              <DrawerFilterItem
                key={index}
                filterConfig={filterConfig}
                index={index}
                handleFilterChange={handleFilterChange}
                classes={classes}
                showSnackbar={showSnackbar}
              />
            ))}

            {/* <div className={classes.drawerButtonGroup}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                className={classes.gradientButton}
                onClick={() => setDrawerOpen(false)}
              >
                Apply
              </Button>
              <Button
                variant="outlined"
                fullWidth
                className={classes.clearButton}
                onClick={handleClearFilters}
              >
                Clear All
              </Button>
            </div> */}

            {/* Active Filters Display */}
            {/* {activeFilters.length > 0 && (
              <>
                <Divider />
                <Typography
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#0b416d",
                    marginTop: "8px",
                  }}
                >
                  Active Filters ({activeFilters.length})
                </Typography>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {activeFilters.length > 0 &&
                    activeFilters.map((filter, idx) => (
                      <Chip
                        key={idx}
                        label={`${filter.label}: ${filter.value}`}
                        onDelete={() =>
                          setActiveFilters((prev) =>
                            prev.filter((f) => f.index !== filter.index)
                          )
                        }
                        className={classes.activeFilterChip}
                      />
                    ))}
                </div>
              </>
            )} */}
          </div>
        </Drawer>
      </>
    );
  },
);

export default EnhancedTableToolbar;
